/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import { Button } from '@mui/material';
import DefaultModal from './DefaultModal';
import Styles from '../../css/EConsentModal.module.css';
import { useState } from 'react';
import LoadingModal from './LoadingModal';

type econsentModalProps = {
  open: boolean;
  onCancel: () => void;
  onAgree: () => void;
};

const EConsentModal = (props: econsentModalProps) => {
  const [iframeLoaded, setIframeLoaded] = useState(false);

  const handleIframeLoad = () => {
    setIframeLoaded(true);
  };

  const econsentModal = () => {
    return (
      props.open && (
        <DefaultModal
          className={Styles.fullmodal}
          open={props.open && iframeLoaded}
          title={<h1>Electronic Record and Signature Disclosure</h1>}
          content={
            <>
              <iframe
                src='https://econsent.swmc.com/'
                className={Styles.iframe}
                title='Example iframe'
                onLoad={handleIframeLoad}
              />
              {!iframeLoaded && <p>Loading...</p>}
            </>
          }
          footer={
            <div className={Styles.footer}>
              <Button
                variant='outlined'
                onClick={() => {
                  setIframeLoaded(false);
                  props.onCancel();
                }}
                className={Styles.cancelButton}
              >
                Cancel
              </Button>
              <Button
                variant='contained'
                onClick={() => {
                  setIframeLoaded(false);
                  props.onAgree();
                }}
                className={Styles.button}
              >
                I Agree
              </Button>
            </div>
          }
        />
      )
    );
  };

  const loadingModal = () => {
    return <LoadingModal open={props.open && !iframeLoaded}></LoadingModal>;
  };

  return (
    <>
      {loadingModal()}
      {econsentModal()}
    </>
  );
};

export default EConsentModal;
